import { ApplicationConfig, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient,withInterceptors } from '@angular/common/http';
import { HttpInterceptor } from './core/interceptors/http.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { provideI18n } from '@corporate/ng-tebis-base-components';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { createMaintenanceInterceptor } from './core/interceptors/maintenance.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    // provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    // provideHttpClient(withInterceptors([HttpInterceptor, errorInterceptor])),
    provideHttpClient(withInterceptors([createMaintenanceInterceptor(environment.baseUrlRds)])),
    provideOAuthClient(),
    provideI18n(),
    provideNativeDateAdapter(),
  ]
};
